import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-blue-gradient-badge',
  templateUrl: './blue-gradient-badge.component.html',
  styleUrls: ['./blue-gradient-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlueGradientBadgeComponent {
  @Input() text: string;
  @Input() selected: boolean;
}
